
export default {
  name: 'MultipleOptionButton',
  props: {
    isDestructive: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    value: {
      default: null,
    },
  },
  computed: {
    computedClassList() {
      return {
        'bb-options-button--destructive': this.isDestructive,
      };
    },
  },
  methods: {
    onClickHandler() {
      this.$emit('click:option', this.value);
    },
  },
};
